import { TextField, TextPassage } from '@petsmart-ui/sparky';
import { get, useFormContext, useWatch } from 'react-hook-form';

import type { FormFields } from '@/entities/purchase-form';

type InputProps = {
    max: number;
    index: number;
    isRequired: boolean;
    name: 'frontLines' | 'backLines';
};

export const Input = ({ index, max, name, isRequired }: InputProps) => {
    const { register, formState, trigger } = useFormContext<FormFields>();

    const fieldName = `personalization.${name}.${index}.text` as const;
    const value = useWatch({ name: fieldName });

    const errorMsg = get(formState.errors, `${fieldName}.message`) as string | undefined;

    return (
        <div className="personalization-drawer__field-wrapper">
            <TextField
                key={fieldName}
                maxLength={max}
                isError={Boolean(errorMsg)}
                data-testid="personalize-input"
                className="personalization-drawer__input-wrapper"
                {...register(fieldName, {
                    required: isRequired,
                    onBlur: () => {
                        trigger(fieldName);
                    },
                })}
                label={`Line ${index + 1}${isRequired ? ' (required)' : ''}`}
            />

            <div className="personalization-drawer__field-meta">
                {errorMsg && (
                    <TextPassage size="sm" className="personalization-drawer__field-error">
                        {errorMsg}
                    </TextPassage>
                )}
                <TextPassage size="sm" className="personalization-drawer__field-count">
                    {value.length}/{max}
                </TextPassage>
            </div>
        </div>
    );
};
